// @flow

import {
  AlphaTheme,
  AlphaTestTheme,
  IttvTheme,
  EllastvmaxTheme,
  EllastvmaxauTheme,
  TvanetplayTheme,
  ZaaptvTheme,
  KratorPlusTheme,
  AsitvTheme,
} from '@alphaott/smart-tv-themes'

import { brandName } from '../containers/RootContainer/const'

// Static brand themes, shared by the app root and the crash screen.
// No side effects on import: the crash screen relies on that.
export const themes = {
  alphaott: AlphaTheme,
  'alphaott-test': AlphaTestTheme,
  ittv: IttvTheme,
  ellastvmax: EllastvmaxTheme,
  ellastvmaxau: EllastvmaxauTheme,
  tvanetplay: TvanetplayTheme,
  zaaptv: ZaaptvTheme,
  kratorplus: KratorPlusTheme,
  asitv: AsitvTheme,
}

export const FALLBACK_BRAND = 'alphaott-test'

// Brand from ?brand= or APP_BRAND; unknown brands get the fallback theme
export const getBrandTheme = (name: ?string = brandName): Object =>
  name && Object.prototype.hasOwnProperty.call(themes, name) ? themes[name] : themes[FALLBACK_BRAND]
